import { SET_CATALOG_DETAIL_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_CATALOG_DETAIL_SETTINGS, {
  isConfiguring: false,
  selectedSourceSlug: '',
  sourceSearchTerm: ''
})
